import { Omrade } from './Omrade';
import { Vegobjekt } from '../vegobjekter/Vegobjekt';

export class Riksvegrute extends Omrade {
    constructor(
        readonly navn: string,
        readonly enumid: number
    ) {
        super(navn, null, null, null, null);
    }

    override(modifyObject: { [P in keyof Riksvegrute]?: Riksvegrute[P] }): Riksvegrute {
        return Object.assign(Object.create(Riksvegrute.prototype), {
            ...this,
            ...modifyObject,
        });
    }

    withVisible(visible: boolean): Riksvegrute {
        return this.override({ visible });
    }

    withVegobjekt(vegobjekt: Vegobjekt): Riksvegrute {
        return this.override({ vegobjekt });
    }

    toString(): string {
        return `${this.navn} ${this.enumid}`;
    }

    toFilterString(): string {
        return `${this.navn}`;
    }

    getAreaType(): string {
        return 'Riksvegrute';
    }

    toParams(): string {
        return this.enumid.toString();
    }
}
